import styled, { css } from "styled-components";
import Icon from "../../../base/icons/icon/index.js";
import { breakpointKeys, breakpointValues } from "../../../../styles/common/breakpoints.js";
import { BoxShadow } from "../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { Padding } from "../../../../styles/common/mixins/logical.styled.js";
import { ScrollHorizontalItem, ScrollHorizontalList } from "../scroll-horizontal/styled.js";
import Slider from "../slider/index.js";
import tabsThemes from "./themes/index.js";
const orientations = {
    horizontal: css``,
    vertical: css`
		${FlexMixin()}
		${tabsThemes('TabsStyledVertical')};
	`
};
// RESOURCES: https://github.com/facebook/jest/issues/12990, https://github.com/facebook/jest/issues/9430
export const TabsStyled = styled.div.withConfig({
    displayName: "styled__TabsStyled",
    componentId: "sc-fa3cfaee-0"
})`
	${BoxShadow}
	background-color: ${({ theme  })=>theme.colors.white.base};
	border-radius: 4px;

	${({ $orientation ='horizontal'  })=>orientations[$orientation]};
`;
export const TabsVerticalWrapper = styled.div.withConfig({
    displayName: "styled__TabsVerticalWrapper",
    componentId: "sc-fa3cfaee-1"
})`
	border-right: 1px solid ${({ theme  })=>theme.border.color.base};

	width: 100%;
	${({ $maxWidth  })=>$maxWidth ? `max-width: ${$maxWidth}` : ''};

	${tabsThemes('TabsVerticalWrapper')}
`;
const getDefaultTabWidth = (perPage, gap = 0)=>{
    if (!perPage) return '';
    const gapString = typeof gap === 'string' ? gap : `${gap}px`;
    return `width: calc(100% / ${perPage} - (${gapString} * 0.8));`;
};
export const TabsCarousel = styled(Slider).withConfig({
    displayName: "styled__TabsCarousel",
    componentId: "sc-fa3cfaee-2"
})`
	margin: 0 8px;

	.splide {
		padding: 0 32px;

		&:not(.is-initialized) {
			.splide__slide {
				${({ perPage , gap =0  })=>getDefaultTabWidth(perPage, gap)}

				${({ breakpoints  })=>{
    if (!breakpoints) return '';
    let finalCss = '';
    for(let i = 0, length = breakpointKeys.length; i < length; i++){
        const breakpointValue = breakpointValues[i];
        const perPage = breakpoints[breakpointValue]?.perPage;
        const gap = breakpoints[breakpointValue]?.gap ?? 0;
        finalCss += getDefaultTabWidth(perPage, gap);
    }
    return finalCss;
}}
			}
		}
	}

	.splide__arrow[disabled] {
		visibility: hidden;
	}
`;
const tabsButtonOrientations = {
    horizontal: css`
		text-align: center;
		text-transform: uppercase;
		border-bottom: 2px solid transparent;
		white-space: nowrap;

		&.is-active {
			${FontMixin({
        size: 'base',
        height: 'base',
        weight: 'medium'
    })}
			border-color: var(--active-border-bottom-color);
			color: var(--active-color);
			padding: 12px 16px;
		}
	`,
    vertical: css`
		position: relative;
		text-align: left;
		border-bottom: 1px solid var(--vertical-border-bottom-color);
		${FlexMixin({
        align: 'center',
        justify: 'space-between'
    })}
		${Padding({
        all: '20px'
    })}

		&.is-active {
			${FontMixin({
        size: 'base',
        height: 'base',
        weight: 'medium'
    })}
			color: var(--active-color);
			border-right-color: transparent;

			&:after {
				content: '';
				position: absolute;
				right: -1px;
				height: 100%;
				width: 1px;
				background-color: ${({ theme  })=>theme.colors.white.base};
			}
		}

		&:last-child {
			border-bottom: 0;
		}
	`
};
export const TabsVerticalIcon = styled(Icon).withConfig({
    displayName: "styled__TabsVerticalIcon",
    componentId: "sc-fa3cfaee-3"
})`
	${tabsThemes('TabsVerticalIcon')}
`;
export const TabsButton = styled.button.withConfig({
    displayName: "styled__TabsButton",
    componentId: "sc-fa3cfaee-4"
})`
	--active-border-bottom-color: ${({ theme  })=>theme.colors.primary.light};
	--vertical-border-bottom-color: ${({ theme  })=>theme.border.color.base};
	--active-color: ${({ theme  })=>theme.colors.primary.light};

	color: ${({ theme  })=>theme.colors.text.light};

	${FontMixin({
    size: 'base',
    height: 'base',
    weight: 'regular'
})}
	${Padding({
    x: '16px',
    y: '12px'
})}

	width: 100%;

	${({ $orientation ='horizontal'  })=>tabsButtonOrientations[$orientation]}

	${tabsThemes('TabsButton')}
`;
export const TabsWrapper = styled.div.withConfig({
    displayName: "styled__TabsWrapper",
    componentId: "sc-fa3cfaee-5"
})`
	position: relative;
	width: 100%;
`;
export const TabsContent = styled.div.withConfig({
    displayName: "styled__TabsContent",
    componentId: "sc-fa3cfaee-6"
})`
	width: 100%;
	height: 100%;

	transition: opacity 0.3s;

	&.is-active {
		opacity: 1;
	}

	&:not(.is-active) {
		opacity: 0;
		display: none; // TODO: Temporary fix for the issue of the content being visible when the tab is not active
	}
`;
export const TabsCarouselList = styled(ScrollHorizontalList).withConfig({
    displayName: "styled__TabsCarouselList",
    componentId: "sc-fa3cfaee-7"
})`
	${FlexMixin({
    align: 'center',
    justify: 'flex-start'
})}
	gap: 0;
	margin: 0;
	padding-bottom: 0;
`;
export const TabsCarouselItem = styled(ScrollHorizontalItem).withConfig({
    displayName: "styled__TabsCarouselItem",
    componentId: "sc-fa3cfaee-8"
})``;

//# sourceMappingURL=styled.js.map